import angular from 'angular'
import templateUrl from './legal-notice-list.component.html'
import { EditLegalNoticeModal } from './edit-legal-notice.component';

export const LegalNoticeListComponent = {
    controller: LegalNoticeListController,
    controllerAs: "vm",
    templateUrl
}

function LegalNoticeListController($uibModal, utilityService, legalNoticeService) {
    'ngInject'
    const vm = this;

    vm.legalNotices = [];

    vm.$onInit = $onInit;
    vm.addNewLegalNotice = addNewLegalNotice;
    vm.editLegalNotice = editLegalNotice;
    vm.deleteLegalNotice = deleteLegalNotice;

    function $onInit() {
        loadLegalNotices();
    }

    function loadLegalNotices() {
        utilityService.showLoading();
        return legalNoticeService.retrieveLegalNotices()
            .then(function (legalNotices) {
                vm.legalNotices = legalNotices;
            })
            .catch(function (ex) {
                alert("Initial load failed: " + (ex.statusText || ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function addNewLegalNotice() {
        showEditForm();
    }

    function editLegalNotice(notice) {
        showEditForm(notice);
    }

    function showEditForm(notice) {
        return $uibModal.open({
            ...EditLegalNoticeModal,
            resolve: {
                legalNotice: () => angular.copy(notice)
            }
        })
            .result
            .then(function (item) {
                return loadLegalNotices();
            });
    }

    function deleteLegalNotice(notice) {

        utilityService.showLoading();
        legalNoticeService.deleteLegalNotice(notice.LegalNoticeID)
            .catch(function (ex) {
                alert("Saving legal notice failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
                loadLegalNotices();
            });
    }

}
